// dashboard-agent-ia/src/App.js
import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { LangProvider } from './context/LangContext'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Register from './pages/Register'
import Contact from './pages/Contact'
import Conditions from './pages/Conditions'
import Confidentialite from './pages/Confidentialite'
import PaymentSuccess from './pages/PaymentSuccess'
import PaymentCancel from './pages/PaymentCancel'
// Admin
import AdminDashboard from './pages/admin/AdminDashboard'
// Business
import BusinessDashboard from './pages/business/BusinessDashboard'
// Ocass
import MerchantDashboard from './pages/ocass/MerchantDashboard'
import OcassSuperAdmin from './pages/ocass/OcassSuperAdmin'
import OcassAuth from './pages/ocass/OcassAuth'

const PrivateRoute = ({ children, role }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" />
  if (role && user.role !== role) return <Navigate to="/login" />
  return children
}

function AppRoutes() {
  // Langue par défaut: français — choisie depuis la Landing page
  if (!localStorage.getItem('lang')) {
    localStorage.setItem('lang', 'fr')
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<OcassAuth />} />
        <Route path="/login-ancien" element={<Login />} />
        <Route path="/inscription" element={<Register />} />
        <Route path="/register" element={<Navigate to="/inscription" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/conditions" element={<Conditions />} />
        <Route path="/confidentialite" element={<Confidentialite />} />

        {/* Paiements */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />

        {/* Admin */}
        <Route path="/admin-dashboard" element={
          <PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>
        } />

        {/* Business */}
        <Route path="/business-dashboard" element={
          <PrivateRoute><BusinessDashboard /></PrivateRoute>
        } />

        {/* Ocass — commerçant (auth interne propre) */}
        <Route path="/ocass" element={<MerchantDashboard />} />
        {/* Ocass — Super Admin (accès direct possible, sinon redirigé depuis /ocass) */}
        <Route path="/ocass/admin" element={<OcassSuperAdmin />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </LangProvider>
  )
}
